<div class="modal-header-row">
  <h5 class="mb-0">{{ achievement ? 'Edit Achievement' : 'Add Achievement' }}</h5>
  <button class="btn-close" (click)="cancel()"></button>
</div>

<div class="modal-body-content">

  <!-- Name + Badge -->
  <div class="row mb-3 align-items-end">
    <div class="col-7">
      <label class="form-label">Name</label>
      <input type="text" class="form-control" [(ngModel)]="formName" placeholder="e.g. First Swipe" />
    </div>
    <div class="col-5">
      <label class="form-label d-flex align-items-center mb-1">
        Badge 
        <i class="pi pi-info-circle ms-2 text-muted" pTooltip="URL / Class / Emoji" tooltipPosition="top" style="font-size: 0.9rem; cursor: pointer;"></i>
      </label>
      <input 
        type="text" 
        class="form-control text-center" 
        [(ngModel)]="formBadge"
        placeholder="🎈, pi pi-star, http..." />
    </div>
  </div>

  <!-- Description -->
  <div class="mb-3">
    <label class="form-label">Description</label>
    <textarea class="form-control" [(ngModel)]="formDescription"
      placeholder="Describe what the user needs to do..." rows="2"></textarea>
  </div>

  <!-- Category + Target -->
  <div class="row mb-3">
    <div class="col-6">
      <label class="form-label">Category</label>
      <select class="form-select" [(ngModel)]="formCategory">
        <option value="" disabled>Select category</option>
        <option value="swipe">Swipe</option>
        <option value="match">Match</option>
        <option value="reward" disabled>Reward</option>
        <option value="share">Share</option>
      </select>
    </div>
    <div class="col-6">
      <label class="form-label">Target Count</label>
      <input type="number" class="form-control" [(ngModel)]="formTarget" placeholder="e.g. 10" min="1" />
    </div>
  </div>

 @if (formName || formBadge) {
<div class="achievement-preview-card">
  <p class="preview-card-title">{{ formName || 'Achievement Name' }}</p>
  <div class="preview-icon-wrap">
    @if (getBadgeType(formBadge) === 'image') {
      <img [src]="formBadge" class="preview-img-badge" alt="Badge" />
    } @else if (getBadgeType(formBadge) === 'icon') {
      <i [class]="formBadge + ' preview-icon-badge'"></i>
    } @else {
      <span class="preview-emoji">{{ formBadge || '?' }}</span>
    }
  </div>
  <div class="preview-ribbon">
    {{ (formCategory || formName || 'reward') | uppercase }}
  </div>
  <span class="preview-status" [class.not-reach]="false">Completed</span>
</div>
}

</div>

<div class="modal-footer-row">
  <button class="btn btn-light border me-2" (click)="cancel()">Cancel</button>
  <button class="btn btn-primary" (click)="save()" [disabled]="isSaving() || !isFormValid()">
    @if (isSaving()) { <i class="pi pi-spin pi-spinner me-2"></i> }
    {{ achievement ? 'Update' : 'Save' }}
  </button>
</div>